import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 40px 0;
`;

const PageLoader = () => (
  <Container>
    <Spin size="large" />
  </Container>
);

export default PageLoader;
